import moment from 'moment';
import { scaleQuantile } from 'd3-scale';
import { ref as $ref } from '@graphistry/falcor-json-graph';
// import { monkey as monkeyPatchMomentRound } from 'spotoninc-moment-round';

// monkeyPatchMomentRound(moment);

export function timebars(view) {
    return {
        timebarsById: {},
        timebars: {
            open: false,
            length: 0,
            id: 'timebars',
            name: 'Timebar',
            encodings: $ref(`${view}.encodings`),
            templates: $ref(`${view}.columns.time`),
            controls: [
                {
                    enabled: false,
                    selected: false,
                    id: 'toggle-timebar',
                    name: 'Timebar'
                }
            ]
        }
    };
}

export const timeDurations = [
    [1, 'millisecond'], [100, 'milliseconds'], [500, 'milliseconds'],
    [1, 'second'], [5, 'seconds'], [15, 'seconds'], [30, 'seconds'],
    [1, 'minute'], [5, 'minutes'], [15, 'minutes'], [30, 'minutes'],
    [1, 'hour'], [3, 'hours'], [6, 'hours'], [12, 'hours'],
    [1, 'day'], [2, 'days'],
    [1, 'week'],
    [1, 'month'], [3, 'months'],
    [1, 'year']
];

export const timeAggregations = scaleQuantile()
    .domain(timeDurations.map(xs => moment.duration(...xs)))
    .range(timeDurations);

// export function dateIncrementors(timeAggregation) {
//     let [count, unit] = timeDurations[timeAggregation];
//     switch (unit) {
//         case 'millisecond':
//             return {
//                 dec: moment => moment,
//                 inc: moment => moment.add(1, 'ms')
//             };
//         case 'hours':
//         case 'minutes':
//         case 'seconds':
//         case 'milliseconds':
//             return {
//                 dec: moment => moment.floor(count, unit),
//                 inc: moment => moment.add(1, 'ms').ceil(count, unit)
//             };
//         case 'days':
//         case 'months':
//             count = Math.ceil(count * 0.5);
//             return {
//                 dec: moment => moment.startOf(unit),
//                 inc: moment => moment.endOf(unit).add(count, unit).add(1, 'ms')
//             };
//     }
//     return {
//         dec: moment => moment.startOf(unit),
//         inc: moment => moment.endOf(unit).add(1, 'ms')
//     };
// }
